import { useContext, useState } from "react"
import { VideoCameraIcon } from "@heroicons/react/24/outline"
import { Panel } from "~/components/CommandMenu/Panel"
import { MultiContext } from "~/contexts/MultiContext"
import { validateNewId } from "./utils"

export function Update() {
  const { updateVideo } = useContext(MultiContext)
  const [newId, setNewId] = useState("")

  const onClick = ({ position, uuid }) => {
    updateVideo(position, uuid, { videoId: validateNewId(newId) })
    setNewId("")
  }

  return (
    <Panel>
      <Panel.Heading>
        <Panel.HeadingDescription>
          Paste a link or YouTube video ID, then select a position to update
        </Panel.HeadingDescription>
        <Panel.HeadingForm id="video-id" value={newId} onChange={setNewId} />
      </Panel.Heading>
      <Panel.Layout Icon={VideoCameraIcon} onClick={onClick} />
    </Panel>
  )
}
